import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Button, Upload as CUpload } from 'antd';
import { fileApi } from 'libs/fileApi';
import{addVisitLog, history} from 'libs';

export default function UploadFile(props) {
  let { fromEntity, color='#409eff', catalog, fromEntityId, isAbleUpload=true, index, setUploadId, itemInfo, exportType } = props
  const [isShowUpload, setIsShowUpload] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [fileId, setFileId] = useState('');

  useEffect(()=>{
    getFileList();
  },[props.fromEntityId])

  // 上传
  const uploadFile = (file)=> {
    let param = new FormData()
    param.append('fileList', file.file)
    param.append('fromEntity', fromEntity)
    param.append('catalog', catalog)
    param.append('fromEntityId', fromEntityId)
    fileApi().upload(param).then((res) => {
      if (!fromEntityId){
        fromEntityId = res.data.result.fromEntityId
        setUploadId(fromEntityId,index,true);
      }else{
        setUploadId(fromEntityId,index,false);
      }
      file.status = 'done'
      file.message = '上传成功'
      getFileList();
    })
  }
  const openUrl = ()=>{
    if (itemInfo) {
      addVisitLog({
        pageName: `${itemInfo.deviceProductName}[${itemInfo.deviceMaterialCode}]`,
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: exportType,
        eventName: "导出校准证书",
        content: JSON.stringify(itemInfo),
      })
    }
    showFile();
  }
  // 获取文件列表
  const getFileList=()=>{
  fileApi().getFilePath({
    fromEntity: fromEntity, catalog: catalog, fromEntityId: fromEntityId
  }).then((res) => {
    setIsShowUpload(true);
    if (res.data.result&&res.data.result.length) {
      const result = res.data.result[0];
      setFilePath(result.filePath);
      setFileId(result.id);
    }else{
      setFilePath('');
      setFileId('');
    }
  })
  }
  const deleteFile=()=>{
    fileApi().delete(fileId).then(res => {
      setFilePath('');
      setFileId('');
    })
  }
  // handleUpload(){
  //   state.$refs.uploadRef.dialogVisible = true;
  // },
  const showFile=()=> {
    // fileApi().getFileStream({
    //   filePath: filePath
    // }).then((res)=>{
    //   console.log(res);
    // })
    window.open(`/javaApi/front/file/getFileStreamById?token=${localStorage.getItem('token')}&id=${fileId}`)
  }

    return (
        <div>
          {
            isShowUpload&&
            <div className="button_container">
              {
                !filePath&&isAbleUpload&&
                <div>
                <CUpload
                  className="upload-demo"
                  action=""
                  customRequest={uploadFile}
                  showUploadList={false}
                >
                  <Button type="text" style={{'color':color}}>上传</Button>
                </CUpload>
              </div>
              }
            {filePath&&<div>
              <Button 
                  onClick={openUrl}
                  // href={`${process.env.REACT_APP_file_domain}/file/getFileStream?x-token=${localStorage.getItem('token')}&filePath=${filePath}`}
                  // rel="noopener noreferrer"
                  // target="_blank"
                  // type='link'
                  type="text"
                  style={{'color':color,padding:0,marginRight:'12px'}}
                  >下载</Button>
              {isAbleUpload&&<Button type="text" onClick={deleteFile} style={{color:'red',padding:0}}>删除</Button>}
            </div>}
          </div>
          }
        </div>
    )
}